import styled from 'styled-components/native'
import {Text} from "react-native"

export const IconWrapper = styled(Text)<{ $isMessage: boolean }>`
    margin: 20px;
    position: absolute;
    right: 0;
    top: ${({ $isMessage }) => $isMessage ? '30px' : 0 };
    z-index: 10;
`
